<template>
  <layout name="LayoutDefault">
    <div class="Authors">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row">
            <div class="col-lg-3 hidden-xs" id="sidefilter">
              <!-- <h3 class="shadow p-3">অনুসন্ধানের ধরন</h3> -->

              <div class="accordion" id="filter">
                <div class="card shadow">
                  <div class="card-header" id="faqhead4">
                    <span class="filter-cancel" @click="cancelSort()">মুছে ফেলুন</span>
                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq3" aria-expanded="true" aria-controls="faq3">বাছাইয়ের ধরন</a>
                  </div>
                  <div id="faq3" class="collapse show" aria-labelledby="faqhead4" data-parent="#faq">
                    <div class="card-body pt-0">
                      <ul>
                        <li class="checkbox">
                          <input @change="sortChange()" type="radio" id="sort1" name="sort" v-model="sort" v-bind:value="`newest`" checked />
                          <label for="sort1">সদ্য তোলা বই</label>
                        </li>
                        <li class="checkbox">
                          <input @change="sortChange()" type="radio" id="sort2" name="sort" v-model="sort" v-bind:value="`oldest`" />
                          <label for="sort2">পুরাতন তোলা বই</label>
                        </li>
                        <li class="checkbox">
                          <input @change="sortChange()" type="radio" id="sort3" name="sort" v-model="sort" v-bind:value="`az`" />
                          <label for="sort3">শিরোনাম (অ–ক্ষ)</label>
                        </li>
                        <li class="checkbox">
                          <input @change="sortChange()" type="radio" id="sort4" name="sort" v-model="sort" v-bind:value="`za`" />
                          <label for="sort4">শিরোনাম (ক্ষ-অ)</label>
                        </li>
                        <li class="checkbox">
                          <input @change="sortChange()" type="radio" id="sort5" name="sort" v-model="sort" v-bind:value="`priceHighToLOw`" />
                          <label for="sort5">দাম: উচ্চ–নিম্ন</label>
                        </li>
                        <li class="checkbox">
                          <input @change="sortChange()" type="radio" id="sort6" name="sort" v-model="sort" v-bind:value="`priceLowToHigh`" />
                          <label for="sort6">দাম: নিম্ন-উচ্চ</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="card shadow">
                  <div class="card-header">
                    <span class="filter-cancel" @click="cancelFilter('category')">মুছে ফেলুন</span>
                    <a href="#" class="btn btn-header-link" data-toggle="collapse" data-target="#faq1" aria-expanded="true" aria-controls="faq1">
                      বিষয়
                    </a>
                  </div>

                  <div id="faq1" class="collapse show" aria-labelledby="faqhead1" data-parent="#faq">
                    <div class="card-body pt-0">
                      <div class="form-group">
                        <input v-model="searchCategory" type="text" placeholder="খুঁজে দেখুন" class="form-control brand-search" />
                      </div>

                      <ul>
                        <li class="checkbox category" v-for="category in filterByCategory" :key="category.id" :data-id="category.id" @click="addToFilter('category')">
                          <input type="checkbox" :id="`category${category.id}`" :value="`${category.id}`" v-model="checkedCategory" />
                          <label :for="`category${category.id}`">{{
                              category.category_name
                          }}</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="card shadow">
                  <div class="card-header">
                    <span class="filter-cancel" @click="cancelFilter('author')">মুছে ফেলুন</span>
                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq2" aria-expanded="true" aria-controls="faq2">লেখক</a>
                  </div>

                  <div id="faq2" class="collapse show" aria-labelledby="faqhead2" data-parent="#faq">
                    <div class="card-body pt-0">
                      <div class="form-group">
                        <input v-model="searchAuthor" type="text" placeholder="খুঁজে দেখুন" class="form-control brand-search" />
                      </div>
                      <ul>
                        <li v-for="author in filterByAuthor" :key="author.id" :data-id="author.id" class="checkbox author" @click="addToFilter('author')">
                          <input type="checkbox" :id="`author${author.id}`" :value="`${author.id}`" v-model="checkedAuthor" />
                          <label :for="`author${author.id}`">{{
                              author.author_name
                          }}</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="card shadow">
                  <div class="card-header" id="faqhead3">
                    <span class="filter-cancel" @click="cancelFilter('price')">মুছে ফেলুন</span>
                    <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#faq3" aria-expanded="true" aria-controls="faq3">মূল্য</a>
                  </div>

                  <div id="faq3" class="collapse show" aria-labelledby="faqhead3" data-parent="#faq">
                    <div class="card-body pt-0">
                      <ul>
                        <li class="checkbox">
                          <input @click="setPrice(0, 499)" type="radio" id="priceslot1" v-model="checkedRange" value="0-499" />
                          <label for="priceslot1">৫০০ টাকার নিচে</label>
                        </li>
                        <li class="checkbox">
                          <input @click="setPrice(500, 999)" type="radio" id="priceslot2" v-model="checkedRange" value="500-999" />
                          <label for="priceslot2">৫০০–৯৯৯ টাকা</label>
                        </li>
                        <li class="checkbox">
                          <input @click="setPrice(1000, 1499)" type="radio" id="priceslot3" v-model="checkedRange" value="1000-1499" />
                          <label for="priceslot3">১০০০–১৪৯৯ টাকা</label>
                        </li>
                        <li class="checkbox">
                          <input @click="setPrice(1500, 1999)" type="radio" id="priceslot4" v-model="checkedRange" value="1500-1999" />
                          <label for="priceslot4">১৫০০–১৯৯৯ টাকা</label>
                        </li>
                        <li class="checkbox">
                          <input @click="setPrice(2000, 1000000)" type="radio" id="priceslot5" v-model="checkedRange" value="2000-1000000" />
                          <label for="priceslot5">২,০০০ টাকার ওপরে</label>
                        </li>
                      </ul>

                      <div class="form-group range mt-2">
                        <h5 class="eng_font">দামের সীমা নির্বাচন করুন</h5>

                        <div class="d-flex">
                          <input type="number" min="0" placeholder="TK. 240" class="form-control low" v-model="priceRangeMin" />
                          <span class="separator">-</span>
                          <input type="number" min="0" max="1000000" placeholder="TK. 10000" class="form-control high" v-model="priceRangeMax" />
                          <input @click="setManualPrice()" type="button" name="submit" value="ক্লিক" class="btn btn-primary" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-9 col-12">
              <div class="bg-white shadow p-3">
                <div class="d-flex align-items-center ">
                  <img v-if="publisher.image" slot="image" v-bind:src="`${IMAGEURL}publisher/${publisher.image}`" alt="Author Photo" class="img-responsive pub-logo p-3" />
                  <h3 class="pl-3">{{ publisher.publisher_name }}</h3>
                </div>

                <hr />

                <div v-if="publisherItems.length > 0">
                  <!-- Page Features -->
                  <div class="py-4 p-3">
                    <div class="row">
                      <div class="col-lg-12 ">
                        <!-- <div class="section-header">
                        <h4>
                          {{ publisher.publisher_name }}-এর
                          {{ publisherItems.length }}টি বই
                        </h4>
                      </div> -->
                        <div class="section-items">
                          <div class="row">
                            <div v-for="(item, index) in publisherItems" v-bind:key="index" class="col-lg-3 col-sm-6 col-6 mb-3">
                              <div class="section-item books">
                                <a :href="
                                  `${baseUrl}book/${item.id}`
                                ">
                                  <!-- <div v-if="item.discount > 0" class="discount-badge">
                                    <span>{{ item.discount }}</span>
                                    <span v-if="item.discount_type == 'Percent'">%</span>
                                    <span v-else class="taka-off">Tk.</span>
                                    <div>OFF</div>
                                  </div> -->

                                  <vue-load-image>
                                    <img slot="image" v-bind:src="
                                      `${IMAGEURL}${item.image}`
                                    " alt="Image" class="img-responsive" />
                                    <img slot="preloader" v-bind:src="
                                      `${IMAGEURL}/assets/img/loader.gif`
                                    " title="Image Loading..." />
                                    <div slot="error">can't load image</div>
                                  </vue-load-image>
                                  <h4 v-if="item.product_name.length < 14">
                                    {{ item.product_name }}
                                  </h4>
                                  <h4 v-if="item.product_name.length >= 14" :title="`${item.product_name}`">
                                    {{
                                        item.product_name.substr(0, 14) + "..."
                                    }}
                                  </h4>
                                  <div class="item-price mt-2">
                                    <div v-if="item.discount > 0" class="item-price">Price: Tk. {{ item.price }}
                                    </div>
                                    <div class="item-regular-price">Regular Price: Tk. {{ item.orginal_price }} </div>
                                  </div>
                                </a>
                                <div class="hover-item">
                                  <div class="arrow-up"></div>
                                  <a href="javascript:;" @click="addToCart(item)" class="btn btn-primary add-to-cart">Add to Cart</a>
                                  <a :href="
                                    `${baseUrl}book/${item.id}`
                                  " class="btn btn-black view-details">View Details</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <nav class="d-flex justify-content-center">
                      <ul class="pagination">
                        <li v-for="(item, k) in links" :key="k" :class="getPagingClass(item)">
                          <a class="page-link" @click="getPublisher(item.url)" href="javascript:;" v-html="getPagingLabel(item)"></a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
                <div v-else>
                  <div v-if="!loading" class="ml-3">
                    কোন বই পাওয়া যায়নি
                    <br />
                    <br />
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Page Content -->

      <!-- /.container -->
    </div>
    <!-- /.container -->
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";
import VueLoadImage from "vue-load-image";

export default {
  data() {
    return {
      publisher: {
        image: ""
      },
      loading: true,
      publisherItems: [],
      authors: null,
      searchAuthor: "",
      categories: null,
      searchCategory: "",
      checkedCategory: [],
      checkedAuthor: [],
      checkedRange: "",
      priceRangeMin: 0,
      priceRangeMax: 1000000,
      links: null,
      sort: this.$route.query.sort ? this.$route.query.sort : "newest"
    };
  },
  components: {
    Layout,
    VueLoadImage
  },
  computed: {
    filterByCategory() {
      if (this.categories) {
        return this.categories.filter(item => {
          return item.category_name.toLowerCase().includes(this.searchCategory);
        });
      }
    },
    filterByAuthor() {
      if (this.authors) {
        return this.authors.filter(item => {
          return item.author_name.toLowerCase().includes(this.searchAuthor);
        });
      }
    }
  },
  methods: {
    cancelFilter(type) {
      if (type === "category") {
        this.checkedCategory = [];
        let url = this.$helper.removeURLParameter("category");
        window.location.href = url;
      } else if (type === "author") {
        this.checkedAuthor = [];
        let url = this.$helper.removeURLParameter("author");
        window.location.href = url;
      } else {
        let url = this.$helper.removeURLParameter("priceRange");
        window.location.href = url;
      }
    },
    cancelSort() {
      this.sort = "newest";
      this.sortChange();
    },
    getPagingLabel(item) {
      let string = item.label;
      string = string.replace("Next", "");
      string = string.replace("Previous", "");
      return string;
    },
    getPagingClass(item) {
      if (item.url && item.active === true) {
        return "page-item active";
      } else if (!item.url) {
        return "page-item disabled";
      } else {
        return "page-item";
      }
    },
    addToFilter(type) {
      //category checked
      var ids = [];
      $("." + type).each(function () {
        let id = $(this).data("id");
        if ($("#" + type + id).is(":checked")) {
          ids.push(id);
        }
      });
      let url = this.$helper.UrlGenerate(type, ids);
      window.location.href = url;
    },
    sortChange() {
      let url = this.$helper.UrlGenerate("sort", this.sort);
      window.location.href = url;
    },
    setPrice(min, max) {
      let url = this.$helper.UrlGenerate("priceRange", min + "-" + max);
      window.location.href = url;
    },
    setManualPrice() {
      let url = this.$helper.UrlGenerate(
        "priceRange",
        this.priceRangeMin + "-" + this.priceRangeMax
      );
      window.location.href = url;
    },
    getCategory() {
      this.$http.get("category-resources").then(response => {
        this.categories = response.data.data;
      });
    },
    getPublisher(url) {
      this.$http
        .get(url)
        .then(response => {
          this.publisher = response.data.publisher;
          this.publisherItems = response.data.publisherBooks.data;
          console.log(this.publisherItems);
          this.links = response.data.publisherBooks.links;
          $(".back-to-top").trigger("click");
          if (this.publisherItems.length < 1) this.loading = false;
        })
        .catch(e => {
          this.publisher = null;
          this.links = null;
          this.loading = false;
        });
    },
    getAuthors() {
      this.$http
        .get("author/all")
        .then(response => {
          this.authors = response.data.data;
        })
        .catch(e => {
          this.authors = null;
        });
    },
    addToCart(row) {
      let itemObj = {
        session_id: localStorage.getItem("session_id"),
        product_id: row.id,
        image: row.image,
        price: row.price,
        quantity: 1,
        name: row.product_name
      };
      this.$helper.saveToCart(itemObj);
      var cartCount = this.$helper.cartCount();
      $(".cart-count").text(cartCount);
      this.flashMessage.success({ message: "Added item to cart" });
    }
  },
  mounted() {
    this.getCategory();
    this.getAuthors();

    let category = this.$route.query.category;
    if (category) {
      this.checkedCategory = category.split(",");
    } else {
      category = "";
    }

    let author = this.$route.query.author;
    if (author) {
      this.checkedAuthor = author.split(",");
    } else {
      author = "";
    }

    this.checkedRange = this.$route.query.priceRange
      ? this.$route.query.priceRange
      : "";
    if (this.checkedRange) {
      let range = this.checkedRange.split("-");
      this.priceRangeMin = range[0];
      this.priceRangeMax = range[1];
    }
    let url =
      "publisher/" +
      this.$route.params.id +
      "?category=" +
      category +
      "&author=" +
      author +
      "&priceRange=" +
      this.checkedRange +
      "&sort=" +
      this.sort;
    this.getPublisher(url);
  }
};
</script>
